var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDownArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 15",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.7 14.7L17.42 7 16 5.59l-6 6V1c0-.55-2-.55-2 0v10.59l-6-6L.59 7l7.7 7.7a1 1 0 001.42 0z",
    fill: "#00F"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTggMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkuNyAxNC43TDE3LjQyIDcgMTYgNS41OWwtNiA2VjFjMC0uNTUtMi0uNTUtMiAwdjEwLjU5bC02LTZMLjU5IDdsNy43IDcuN2ExIDEgMCAwMDEuNDIgMHoiIGZpbGw9IiMwMEYiIGZpbGwtcnVsZT0ibm9uemVybyIvPjwvc3ZnPg==";
export { SvgDownArrow as ReactComponent };